import { isEmpty } from "@swiggy-private/js-utils";
import { getFormattedNumber } from "@swiggy-private/super-ui";

import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { isToingFlow } from "@swiggy-private/checkout-core";
import { getToingRtbHeaderLottieArray } from "@cart-client/hooks/useToingRtbHeaderLottie/helpers";

const TOTAL_DISCOUNT_PLACEHOLDER = "{{total_discount}}";

export function interpolateTotalDiscountInSavingsCallout(
    text: string | undefined,
    totalDiscount: number | undefined,
): string {
    if (isEmpty(text)) {
        return "";
    }
    if (isEmpty(totalDiscount) || !text.includes(TOTAL_DISCOUNT_PLACEHOLDER)) {
        return text;
    }
    return text.split(TOTAL_DISCOUNT_PLACEHOLDER).join(`₹${getFormattedNumber(totalDiscount)}`);
}

export const isToingRtbXp = (cartResponse: ReviewedCart | null): boolean => {
    return isToingFlow() && getToingRtbHeaderLottieArray(cartResponse).length > 0;
};
